// extracted by mini-css-extract-plugin
export default {"box_modal":"DetailFood_box_modal__5rvB-"};